import { BASKET_TYPES, selectBasketDeliveries, selectBasketList, selectBasketToPay } from 'containers/OrderDetails/basketSlice'
import { useReduxSelector } from 'store'

const useCartItemDeliveries = (
  cartId: string
) => {
  const list = useReduxSelector(selectBasketList)
  const toPay = useReduxSelector(selectBasketToPay)
  const deliveries = useReduxSelector(selectBasketDeliveries)
  const relatedCartPositionWithDelivery = filterCartListByRelationToItem(list, cartId, toPay)

  const processData = () => {
    if (!relatedCartPositionWithDelivery || relatedCartPositionWithDelivery?.items?.length === 0) return
    const relatedDeliveries = getRelatedDeliveries(relatedCartPositionWithDelivery.items, deliveries) as basic.Form[]
    return {
      data: relatedDeliveries.reduce((r, delivery) => {
        r[delivery.id] = delivery
        return r
      }, {}),
      itemsWithPrice: relatedCartPositionWithDelivery.itemsWithPrice,
      deliveries: relatedDeliveries
    }
  }

  return processData()
}

const getRelatedDeliveries = (products: basic.Form[], deliveries: basic.Form[]) => {
  return deliveries.reduce((result, item) => {
    const relatedProducts = products.filter(p => p.deliveryId === item.id)
    if (relatedProducts.length > 0) {
      result.push({ ...item, products: relatedProducts })
    }
    return result
  }, [])
}

const filterCartListByRelationToItem = (list: basic.Form[], cartId: string, toPay?: Record<string, basic.Form>) => {
  if (!list || !cartId) return
  const placeId = list.find(i => i.identifier === cartId)?.placeId
  const additionalCartItemList: basic.Form[] = list.map(item => {
    return toPay && toPay[item.identifier]
      ? { ...item, externalDeliveryId: toPay[item.identifier].deliveryId }
      : item
  })

  return list.reduce((result, item) => {
    let isValid = false
    if (item.type === BASKET_TYPES.rentAddon) {
      const isRelated = item.ownerId
        ? item.ownerId === cartId
        : item.related
          ? (item.related.some((r: basic.Form) => r.cartId === cartId || r.id === item.placeId))
          : placeId === item.placeId
      isValid = isRelated && item.deliveryId
    } else if (item.type === BASKET_TYPES.shop && item.ownerId === cartId && item.deliveryId) {
      isValid = true
    }

    if (isValid) {
      const externalDeliveryId = toPay?.[item.identifier]?.deliveryId
      const showDeliveryPrice = toPay && externalDeliveryId
        ? additionalCartItemList.find(i => i.externalDeliveryId === externalDeliveryId)?.identifier === item.identifier
        : false
      result.items.push(item)
      if (showDeliveryPrice) {
        result.itemsWithPrice.push({ ...item, externalDeliveryId })
      }
    }
    return result
  }, {
    items: [] as basic.Form[],
    itemsWithPrice: [] as basic.Form[]
  })
}
export default useCartItemDeliveries